
export const PAYMENTS_NEGOTIATION = 'PAYMENTS_NEGOTIATION'
